import { render, staticRenderFns } from "./searchTag.vue?vue&type=template&id=0f8def1e&scoped=true&"
import script from "./searchTag.vue?vue&type=script&lang=js&"
export * from "./searchTag.vue?vue&type=script&lang=js&"
import style0 from "./searchTag.vue?vue&type=style&index=0&id=0f8def1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8def1e",
  null
  
)

export default component.exports